import { REGION_MAP_SVGS } from "../data/regionMapSvg";

export default function PresenceRegionDetail({ regionId, zoomed = false }) {
  const region = REGION_MAP_SVGS[regionId];
  if (!region) return null;

  const { x, y } = region.pin;

  return (
    <div className={`presence-region-detail${zoomed ? " presence-region-detail--zoomed" : ""}`}>
      <div className="presence-region-detail__header">
        <h3>{region.title}</h3>
        <p>{region.subtitle}</p>
      </div>
      <svg
        className="presence-region-detail__svg"
        viewBox={region.viewBox}
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label={`${region.title} presence map`}
      >
        <rect className="presence-region-ocean" width="100%" height="100%" />
        <path className="presence-region-outline" d={region.outline} />
        <circle className="presence-region-pin-ring" cx={x} cy={y} r="18" />
        <circle className="presence-region-pin-core" cx={x} cy={y} r="8" />
        <line
          className="presence-region-pin-stem"
          x1={x}
          y1={y - 8}
          x2={x}
          y2={y - 28}
        />
        <circle className="presence-region-pin-head" cx={x} cy={y - 32} r="7" />
        <text
          x={x + 12}
          y={y - 36}
          className="presence-region-pin-label"
        >
          {region.title}
        </text>
      </svg>
    </div>
  );
}
